import { createAction } from '@reduxjs/toolkit';

import {
  WebSocketBulkActionFinishedInboundMessage,
  WebSocketBulkActionStartedInboundMessage,
} from 'middleware/webSocket';

import {
  ConversationBulkModalEndpointCallPayload,
  ConversationsBulkModalInitPayload,
} from './types/conversationsBulkModalActions.types';

const prefix = 'conversationsBulkModal';

export const conversationsBulkModalActions = {
  initBulkUpdate: createAction<ConversationsBulkModalInitPayload>(
    `${prefix}/initUpdate`,
  ),
  callEndpoint: createAction<ConversationBulkModalEndpointCallPayload>(
    `${prefix}/callEndpoint`,
  ),
  startBulkUpdate: createAction<WebSocketBulkActionStartedInboundMessage>(
    `${prefix}/startBulkUpdate`,
  ),
  finishBulkUpdate: createAction<WebSocketBulkActionFinishedInboundMessage>(
    `${prefix}/finishBulkUpdate`,
  ),
};
